import React from 'react';
import { Navigate } from 'react-router-dom';
import { useInfluencerAuth } from '../../contexts/InfluencerAuthContext';

const InfluencerProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useInfluencerAuth();

  // Show loading while checking auth
  if (loading) {
    return (
      <div className="influencer-loading">
        <div className="loading-spinner"></div>
        <p>Carregando...</p>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/influencer/login" replace />;
  }

  return children;
};

export default InfluencerProtectedRoute;

